import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
const ElysSendDeceasedSocioEconomicInformationController = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ElysSendDeceasedSocioEconomicInformationController.url(args, options),
    method: 'put',
})

ElysSendDeceasedSocioEconomicInformationController.definition = {
    methods: ["put"],
    url: '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
ElysSendDeceasedSocioEconomicInformationController.url = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            dossier_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        dossier_id: args.dossier_id,
    }

    return ElysSendDeceasedSocioEconomicInformationController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{dossier_id}', parsedArgs.dossier_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysSendDeceasedSocioEconomicInformationController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysSendDeceasedSocioEconomicInformationController.php
* @route '/api/company/{company}/elys/dossier/{dossier_id}/socio-economic-information'
*/
ElysSendDeceasedSocioEconomicInformationController.put = (args: { company: string | number | { id: string | number }, dossier_id: string | number } | [company: string | number | { id: string | number }, dossier_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ElysSendDeceasedSocioEconomicInformationController.url(args, options),
    method: 'put',
})

export default ElysSendDeceasedSocioEconomicInformationController